import type { FC } from 'react';

import {
  AlsoConnectedTo,
  CallDetailsAddHearing,
  CallDetailsParticipant,
} from 'features/call/call-details/components';
import type { CallDetailsParticipantInfo } from 'features/call/call-details/interfaces';
import { Separator } from 'features/call/call-details/styles';
import { CustomGreeting } from 'features/custom-greeting/components';
import { WavelloCallTitle } from 'features/wavello/components';

export interface CallDetailsCalleeConnectedProps {
  callee: CallDetailsParticipantInfo;
  caller: CallDetailsParticipantInfo;
}

export const CallDetailsCalleeConnected: FC<
  CallDetailsCalleeConnectedProps
> = ({ callee, caller }) => {
  const isWawelloCallActive =
    callee.isWavelloCallActive || caller.isWavelloCallActive;

  return (
    <>
      {isWawelloCallActive && (
        <>
          <WavelloCallTitle />
          <Separator />
        </>
      )}
      <CustomGreeting />
      <CallDetailsParticipant {...caller} />
      <Separator />
      <CallDetailsParticipant {...callee} />
      <CallDetailsAddHearing />
      <AlsoConnectedTo />
    </>
  );
};
